<div class="lds-container h250 mt-2 SD-graph-main">
  @if (loading) {
    <lds-progress-spinner></lds-progress-spinner>
  }
  <canvas id="graph" [hidden]="!graph">{{graph}}</canvas>
</div>
<div class="below-graph">
  <button id="reset-graph-button" class="lds-btn active" (click)="resetGraph()">Reset Graph</button>
</div>
